import React from "react";
import Feature from "../components/feature";

import ImageCard from "../components/image-card";
import Map from "../components/map";
import Slider from "../components/slider";
import data from "../data/data";

import "../styles/home.scss";

const Home = ({ setCategory }) => {
  return (
    <div className="home-page">
      <div>
        <Slider />
      </div>
      <main className="main-content">
        <section className="home__features">
          <div className="home__features-container">
            <div className="home__features-header">
              {/* <div className="home__features-tag">FEATURES</div> */}
              <h1 className="home__features-title">Why choose us?</h1>
              <p className="home__features-description">
                We prepare your food with love and passion!
              </p>
            </div>
            <div className="home__features-content">
              {data.features.map((feature, index) => (
                <Feature feature={feature} key={index} icon={feature.icon} />
              ))}
            </div>
          </div>
        </section>
        <section className="home__menu-gallery">
          <div className="home__menu-gallery-container">
            <div className="home__menu-gallery-header">
              <h1>GALLERY OF OUR DISHES</h1>
            </div>
            <div className="home__menu-gallery-content">
              {Object.keys(data.menu).map((category, index) => (
                <ImageCard
                  content={category}
                  imageUrl={data.menu[category][0]["imageUrl"]}
                  key={index}
                  totalItems={data.menu[category].length}
                  setCategory={setCategory}
                />
              ))}
            </div>
          </div>
        </section>
        <section className="home__working-hours">
          <h1>Hours of Operation</h1>
          <div className="home__working-hours-container">
            <div className="home__working-hours-image-container">
              <img alt="" />
            </div>
            <div className="home__working-hours-content">
              {/* <div> */}
              <div className="home__working-hours-title">Hours</div>
              {data.timings.map((timings, index) => {
                return (
                  <div className="home__working-hours-timings" key={index}>
                    <div className="home__working-hours-day">
                      {timings.day}:
                    </div>
                    <div className="home__working-hours-time">
                      {timings.hours}
                    </div>
                  </div>
                );
              })}
              {/* </div> */}
            </div>
          </div>
        </section>
        <section className="home__map">
          <h1>Where to find us</h1>
          <div id="map">
            <Map />
          </div>
        </section>
      </main>
    </div>
  );
};

export default Home;
